<template>
    <h3 class="text-center mt-4">Thanks for your application</h3>
    <!-- the app does not exist -->
    <div class="" v-if="!application">
        <div class="d-grid gap-2 col-6 mx-auto my-3">
            <a class="btn btn-primary" href="/loan">Apply</a>
        </div>
    </div>
    <div v-else>
        <div class="" v-if="mustRedirect && redirectUrl">
            <h4 class="text-center mt-4">We are loading your results...</h4>
        </div>
        <div v-else>
            <!-- We found a match for the user -->
            <div class="my-5" v-if="buyers">
                <!-- Buyers Section -->
                <Buyers :buyers="buyers" />

                <!-- Tabs section (Tabs, Tab, CreditScore components) removed — components were unused dead code -->
            </div>
            <div v-else>
                <!-- NO match -->
                <div class="my-3">
                    <h4 class="text-center">Unfortunately we were unable to match you with a service provider at this time.</h4>
                </div>
                <div class="d-grid gap-2 col-6 mx-auto my-3">
                    <a class="btn btn-primary my-2" href="/loan" target="_blank">Get Your Free Credit Score Now</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import { computed, onMounted } from 'vue';

import Buyers from '@/components/processed-application/Buyers.vue';

const props = defineProps({
    application: {
        type: Object,
    },
    mustRedirect: {
        type: Boolean,
        default: true,
    },
memberPortalUrl: {
        type: String,
        default: 'https://compare.loanscanada.ca',
    },
});

function redirectTo(url) {
    window.location.href = url;
}

const buyers = computed(() =>
    props.application && props.application.buyers && Object.keys(props.application.buyers).length > 0
        ? props.application.buyers
        : null
);

const redirectUrl = computed(() =>
    props.application && props.application.redirectUrl
        ? props.application.redirectUrl
        : null
);

// Only ever set when the submit came back without a usable outcome but we do know which
// lead it was. Not part of the happy path.
const thankYouUrl = computed(() =>
    props.application && props.application.thankYouUrl
        ? props.application.thankYouUrl
        : null
);

onMounted(() => {
    // We couldn't tell what happened to this submit, but the lead exists in CMI and may
    // have been sold after we stopped listening. Send the user to its thank-you page,
    // which asks CMI for the real outcome, instead of showing "unable to match you" for
    // an application that may well have matched. Checked before mustRedirect because
    // there is no redirectUrl to interstitial through in this case.
    if (thankYouUrl.value) {
        redirectTo(thankYouUrl.value);
        return;
    }

    if (props.mustRedirect && redirectUrl.value) {
        // this is gonna send the user to the loading interstitial page where we load the pixel
        // and then we redirect to the redirectUrl
        redirectTo('/redirect');
    }
});

</script>
